module.exports = __webpack_public_path__ + "img/icon-park_application-menu.71ec5aaa.svg";